

export const useSnpChatPublicApi = {
    registerChatKey: () => { },
    registerUserDetails: () => { },
    setCustomToastFunc: () => { },
    deRegisterKey: () => { }
};
